import { Box, BoxProps } from '@mui/material';

export interface ISpriteIconProps extends Pick<BoxProps, 'sx' | 'className'> {
  src: string;
}

/**
 * Renders an SVG icon using a [vite-plugin-svg-sprite](https://www.npmjs.com/package/vite-plugin-svg-sprite).
 */
export function SpriteIcon({
  src,
  sx,
  ...restProps
}: ISpriteIconProps): JSX.Element {
  return (
    <Box
      {...restProps}
      sx={{ width: '1em', height: '1em', ...sx }}
      component="svg"
    >
      <use xlinkHref={`#${src}`} />
    </Box>
  );
}
